<template>
  <div class="address-container">
    <top></top>
    <template v-if="list.length">
      <div class="address-wrapper">
        <div class="address-item" v-for="item in list" :key="item.id" @click="toEdit(item)">
          <div class="left">
            <div class="top">
              <div v-if="item.default">默认</div>
              <span style="color: #4a4a4a;font-weight: 600;">{{item.name}}</span><span>{{item.mobile}}</span>
            </div>
            <p>{{item.province}}{{item.city}}{{item.district}}{{item.address}}</p>
          </div>
          <img src="../../../assets/icon/icons8-right_4@2x.png">
        </div>
      </div>
    </template>
    <template v-else>
      <p class="blank">暂无纪录</p>
    </template>
    <div class="address-new" @click="newAddress">+ 新增收货地址</div>
  </div>
</template>

<script>
import Vue from 'vue'
import top from '@/components/top'
import { mapGetters } from 'vuex'
import area from '@/util/area'
import { Toast } from 'vant'

Vue.use(Toast)

export default {
  name: 'Address',
  components: { top },
  data() {
    return {
      area: area,
      list: []
    }
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['userInfo', 'token'])
  },
  methods: {
    getList() {
      var that = this
      this.axios.get('/user/address').then(function(res) {
        that.list = res.data.results
      }).catch(function(error) {
        console.log(error)
      })
    },

    toEdit(item) {
      if (this.$route.query.action === 'select') {
        this.$router.replace({ path: '/goods/exchange', query: { addressId: item.id, productId: this.$route.query.productId, lotteryId: this.$route.query.lotteryId }})
      } else {
        this.$router.push({ path: '/user/address/edit', query: { id: item.id }})
      }
    },

    newAddress() {
      this.$router.push({ path: '/user/address/edit' })
    }
  }
}
</script>

<style lang="scss" scoped>
.address-container{
  .address-wrapper{
    margin-top: 60px;
    .address-item{
      width: 325px;
      height: 80px;
      margin: 0 auto;
      background-color: #ffffff;
      margin-bottom: 1px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      line-height: 25px;
      .top{
        display: flex;
        align-items: center;
        div{
          width: 31px;
          height: 16px;
          border-radius: 2px;
          background-color: #003485;
          color: #ffffff;
          font-size: 10px;
          font-weight: 400;
          text-align: center;
          line-height: 16px;
          margin-right: 5px;
        }
        span{
          color: #747474;
          font-size: 14px;
          font-weight: 400;
          margin-right: 5px;
        }
      }
      p{
        width: 300px;
        color: #747474;
        font-size: 12px;
        font-weight: 400;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      img{
        width: 6px;
        height: 10px;
      }
    }
  }
  .address-new{
    width: 365px;
    height: 80px;
    margin: 0 auto;
    background-color: #ffffff;
    text-align: center;
    line-height: 80px;
    color: #4a4a4a;
    font-size: 14px;
    font-weight: 400;
  }
  .blank{
    text-align: center;
    color: #4a4a4a;
    font-size: 14px;
    font-weight: 400;
    margin: 230px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/address/index.vue